/**
 * The IncentiWise "Uplift Steps" brand mark (IB-258 — design doc §5, source
 * geometry/colours: `docs/brand/incentiwise-mark.svg`). Three rising rounded
 * bars in a light-to-deep emerald ramp plus a chevron "tick", read left to
 * right as an ascending, resolved trajectory.
 *
 * This is the **one sanctioned place** (alongside `accentPreference.ts`'s
 * preset data and `BrandLockup.tsx` below) for literal hex in the frontend
 * (CLAUDE.md §4 "components consume CSS variables, never literal hex").
 * These four colours are fixed brand identity — the mark must render
 * identically regardless of the active theme or the user's chosen accent,
 * so they are intentionally NOT theme tokens: a user picking "Coral" as
 * their accent must not turn the logo coral.
 */
const BAR_LIGHT = '#7FD9BC'
const BAR_MID = '#3FC79E'
const BAR_DEEP = '#12B886'
const TICK = '#0E9C6F'

export interface BrandMarkProps {
  /** Rendered width/height in px — the mark's viewBox is a 1:1 square. Default 24. */
  size?: number
  /** Accessible name. Default "IncentiWise". Pass `''` only if an ancestor already labels it. */
  title?: string
}

/** Inline SVG (not emoji, not raster) — CLAUDE.md §4 "Icons: modern SVG line icons... No emoji". */
export function BrandMark({ size = 24, title = 'IncentiWise' }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      role="img"
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <rect x="6" y="29" width="9" height="12" rx="3" fill={BAR_LIGHT} />
      <rect x="19.5" y="21" width="9" height="20" rx="3" fill={BAR_MID} />
      <rect x="33" y="12" width="9" height="29" rx="3" fill={BAR_DEEP} />
      <path
        d="M33 9.5 L37.5 5 L42 9.5"
        fill="none"
        stroke={TICK}
        strokeWidth={3.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
